import * as React from 'react'
import * as classNames from 'classnames'

import * as Style from './style.css'

import PcPinkCommonArrorRight from './pc_pink_common_arrow_right.svg?reactCompornt'
import PcBlueCommonArrorRight from './pc_blue_common_arrow_right.svg?reactCompornt'
import SpPinkCommonArrorRight from './sp_pink_common_arrow_right.svg?reactCompornt'
import SpBlueCommonArrorRight from './sp_blue_common_arrow_right.svg?reactCompornt'

type IButtonType = typeof BUTTON_TYPE_PINK | typeof BUTTON_TYPE_BLUE

export interface IProps {
  buttonType: IButtonType
  accordionTitle: string
  href: string
  pageTransitionHandler: (href: string) => void
}

export const BUTTON_TYPE_PINK = 'PINK'
export const BUTTON_TYPE_BLUE = 'BLUE'

export const ArrowLinkButton = React.forwardRef<HTMLInputElement, IProps>(
  (
    { buttonType, accordionTitle, href, pageTransitionHandler, ...props },
    ref,
  ) => {
    const buttonClass = {
      [Style.ArrowLinkButtonSitter]: buttonType === BUTTON_TYPE_PINK,
      [Style.ArrowLinkButtonHousekeeping]: buttonType === BUTTON_TYPE_BLUE,
    }
    const labelClass = {
      [Style.ArrowLinkButtonTitleSitter]: buttonType === BUTTON_TYPE_PINK,
      [Style.ArrowLinkButtonTitleHousekeeping]: buttonType === BUTTON_TYPE_BLUE,
    }

    return (
      <button
        className={classNames(buttonClass)}
        type="button"
        onClick={() => pageTransitionHandler(href)}
      >
        <div className={classNames(labelClass)}>{accordionTitle}</div>
        {buttonType === BUTTON_TYPE_PINK && (
          <>
            <PcPinkCommonArrorRight
              className={classNames(
                Style.ArrowLinkButtonArrow,
                Style.TabletPcOnly,
              )}
            />
            <SpPinkCommonArrorRight
              className={classNames(Style.ArrowLinkButtonArrow, Style.SpOnly)}
            />
          </>
        )}
        {buttonType === BUTTON_TYPE_BLUE && (
          <>
            <PcBlueCommonArrorRight
              className={classNames(
                Style.ArrowLinkButtonArrow,
                Style.TabletPcOnly,
              )}
            />
            <SpBlueCommonArrorRight
              className={classNames(Style.ArrowLinkButtonArrow, Style.SpOnly)}
            />
          </>
        )}
      </button>
    )
  },
)
